import Vue from 'vue'
import Router from 'vue-router'
import Map from '@/components/Map'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import ControlPanel from '@/components/ControlPanel'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: '/',
  routes: [
    {
      path: '/map/:projectId',
      name: 'Map',
      component: Map
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'ControlPanel',
      component: ControlPanel
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js